import type { FilterField } from './advancedFilter.types';

interface DateLimits {
  minDate: string | undefined;
  maxDate: string | undefined;
}

function readLinkedDate(
  values: Record<string, string>,
  linkedKey: string | undefined,
): string | undefined {
  if (linkedKey === undefined) return undefined;
  return values[linkedKey] || undefined;
}

function tighter(
  a: string | undefined,
  b: string | undefined,
  pick: (a: string, b: string) => string,
): string | undefined {
  if (a === undefined) return b;
  if (b === undefined) return a;
  return pick(a, b);
}

export function getDateLimits(field: FilterField, values: Record<string, string>): DateLimits {
  return {
    minDate: tighter(field.minDate, readLinkedDate(values, field.minDateKey), (a, b) =>
      a > b ? a : b,
    ),
    maxDate: tighter(field.maxDate, readLinkedDate(values, field.maxDateKey), (a, b) =>
      a < b ? a : b,
    ),
  };
}
